import { defineStore } from 'pinia'

const loadSessionState = (key, fallback) => {
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) return fallback
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : fallback
  } catch (e) {
    return fallback
  }
}

const persistSessionState = (key, payload) => {
  try {
    if (payload) {
      sessionStorage.setItem(key, JSON.stringify(payload))
    } else {
      sessionStorage.removeItem(key)
    }
  } catch (e) {
    // Ignore sessionStorage errors
  }
}

export const useInsureApplyStore = defineStore('insureApply', {
  state: () => ({
    selectedLandPlots: [],
    insureApplyState: loadSessionState('insureApplyState', null),
    mapUiState: loadSessionState('insureApplyMapUiState', { boundaryOnly: false })
  }),
  actions: {
    addSelectedLandPlot (landPlot) {
      const existingIndex = this.selectedLandPlots.findIndex(plot => plot.land_id === landPlot.land_id)
      if (existingIndex === -1) {
        this.selectedLandPlots.push(landPlot)
      }
    },
    clearSelectedLandPlots () {
      this.selectedLandPlots = []
    },
    setInsureApplyState (payload) {
      this.insureApplyState = payload || null
      persistSessionState('insureApplyState', this.insureApplyState)
    },
    clearInsureApplyState () {
      this.setInsureApplyState(null)
    },
    setBoundaryOnly (enabled) {
      const nextMapUiState = {
        ...(this.mapUiState || {}),
        boundaryOnly: !!enabled
      }
      this.mapUiState = nextMapUiState
      persistSessionState('insureApplyMapUiState', nextMapUiState)
    },
    clearMapUiState () {
      this.mapUiState = { boundaryOnly: false }
      persistSessionState('insureApplyMapUiState', null)
    }
  }
})
